<app-breadcrumb [title]="'Dashboard'"></app-breadcrumb>

<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card mb-3">
                <div class="card-body">
                    <div class="d-flex flex-column flex-md-row">
                        <p class="lead">
                            <span class="fw-bold" *ngIf="(region$ | async);let region">Hi,
                                {{ region.name }}.</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <app-statistic></app-statistic>
        </div>
    </div>
</div>